import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContent";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user) return <Navigate to="/dashboard" replace />;

  return children;
};

export default PublicRoute;
